import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { requestBusinessPrioritiesApplyChanges, useBusinessPrioritiesView } from '../../../model'
import {
  selectBusinessPrioritiesUserInfo,
  selectEditingPriority,
  selectGeoMarkets,
} from '../../../model/selectors'
import { IBusinessPriorityForm } from '../../../model/types'
import { BusinessPrioritiesEditHeader } from '../../businessPrioritiesEditHeader'
import { BusinessPriorityForm } from '../../businessPriorityForm'

const BUSINESS_PRIORITY_FORM_KEY = 'businessPriorityForm'

export const BusinessPrioritiesEditView: FC = () => {
  const userInfo = useSelector(selectBusinessPrioritiesUserInfo)
  const isWorldWide = useMemo(() => userInfo?.viewType === 'WorldWide', [userInfo])
  const market = useMemo(() => userInfo?.market, [userInfo])
  const geoMarkets = useSelector(selectGeoMarkets)
  const marketOptions = useMemo(() => geoMarkets.map((geoMarket) => geoMarket.short), [geoMarkets])
  const { goToList } = useBusinessPrioritiesView()
  const editingPriority = useSelector(selectEditingPriority)
  const dispatch = useAppDispatch()

  const handleSubmit = async (form: IBusinessPriorityForm) => {
    try {
      await dispatch(requestBusinessPrioritiesApplyChanges(form)).unwrap()
      goToList()
    } catch {
      // slice already records the error; stay on the form
    }
  }

  return (
    <>
      <BusinessPrioritiesEditHeader isWorldwide={isWorldWide} market={market} />
      <BusinessPriorityForm
        formKey={BUSINESS_PRIORITY_FORM_KEY}
        isWorldwide={isWorldWide}
        market={market}
        marketOptions={marketOptions}
        initialData={editingPriority}
        onSubmit={handleSubmit}
        onCancel={goToList}
      />
    </>
  )
}

BusinessPrioritiesEditView.displayName = 'BusinessPrioritiesEditView'

export default BusinessPrioritiesEditView
